// src/modules/public/pages/LoginPage/index.js
import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../../shared/hooks/useAuth';
import { useAlert } from '../../../../shared/hooks/useAlert';
import LoginForm from '../../components/LoginForm';
import Loading from '../../../../shared/components/Loading';

const LoginPage = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { login, isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const { alert, showSuccess, showError, hideAlert } = useAlert();

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/fithub');
        }
    }, [isAuthenticated, navigate]);

    useEffect(() => {
        if (location.state?.successMessage) {
            showSuccess(location.state.successMessage);
        }
    }, []);

    const handleLogin = async (credentials) => {
        setIsLoading(true);
        try {
            await login(credentials);
            navigate('/fithub');
        } catch (error) {
            showError(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Container className="mt-5">
            {isLoading ? (
                <Loading></Loading>
            ) : (
                <LoginForm
                    onSubmit={handleLogin}
                    isLoading={isLoading}
                    alert={alert}
                    onAlertClose={hideAlert}
                />
            )}
        </Container>
    );
};

export default LoginPage;
